import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { UntypedFormArray, UntypedFormGroup } from "@angular/forms";

import { Observable } from "rxjs";

import { markAsTouched, updateValueAndValidity } from "@dffedb/forms";
import { DffRouteParams } from "@dffedb/router";
import { scrollIntoView } from "@dffedb/ui";
import { nullInstallationNr } from "@e-forsyning/common/maaler";
import { RedirectService } from "@e-forsyning/common/router";

import { OpgaveLocalstorageService } from "../shared/opgave.localstorage.service";
import { OpretKomponentEventArgs } from "./arbejdsgang/komponenter/komponent-gruppe/komponent-gruppe.component";
import { KomponentFormBuilder } from "./arbejdsgang/komponenter/komponent.form-builder";
import { opretTomKomponent } from "./arbejdsgang/komponenter/model/komponent.model";
import { OpgaveViewModel } from "./model/opgave.view-model";
import { OpgaveSandbox } from "./opgave.sandbox";

@Component({
    selector: "servicerapport-opgave",
    templateUrl: "./opgave.component.html",
    styleUrls: ["./opgave.component.scss"]
})
export class OpgaveComponent implements OnInit {
    @ViewChild("udfoerKnap", { read: ElementRef }) public udfoerKnap: ElementRef;

    public vm$: Observable<OpgaveViewModel>;
    public udfoererOpgave = false;
    public opgaveUdfoertMedSuccess = false;
    public error: any;
    public nullInstallationNr = nullInstallationNr;
    public progress$ = this.sandbox.progress$;

    constructor(
        private readonly sandbox: OpgaveSandbox,
        private readonly komponentFormBuilder: KomponentFormBuilder,
        private readonly localstorageService: OpgaveLocalstorageService,
        private readonly redirectService: RedirectService,
        private readonly routeParams: DffRouteParams
    ) {}

    public ngOnInit(): void {
        this.vm$ = this.sandbox.hentViewModel(this.opgaveId);
    }

    public onOpretKomponent(args: OpretKomponentEventArgs): void {
        const komponent = opretTomKomponent(args.komponentType);
        const komponentFormGroup = this.komponentFormBuilder.komponentToFormGroup(komponent, args.komponentType, [], [], [], []);
        const komponentArray = args.formGroup.controls["komponenter"] as UntypedFormArray;
        komponentArray.insert(komponentArray.length, komponentFormGroup);
    }

    public async onUdfoerOpgaveClick(formGroup: UntypedFormGroup): Promise<void> {
        // Sørg for at alle valideringer vises
        markAsTouched(formGroup);
        updateValueAndValidity(formGroup);

        // Vi ønsker kun at udføre opgaven, hvis alle felter er valide
        if (formGroup.invalid) {
            return;
        }

        this.udfoererOpgave = true;
        try {
            await this.sandbox.udfoerOpgave(formGroup);
            this.localstorageService.sletOpgave(this.opgaveId);
            this.opgaveUdfoertMedSuccess = true;
            this.udfoererOpgave = false;
        } catch (error) {
            this.error = error;
            this.udfoererOpgave = false;
            setTimeout(() => scrollIntoView(this.udfoerKnap.nativeElement), 100);
            throw error;
        }
    }

    public navigerTilInstallationer(): void {
        this.redirectService.redirectTilInstallationer(); // redirect("install-picker/opgaver");
    }

    public navigerTilOversigt(): void {
        this.redirectService.redirect("opgaver");
    }

    private get opgaveId(): number {
        return +this.routeParams.get("id");
    }
}
